const fonts = {
mainFont: '"Poppins", sans-serif',
};
  
export default fonts;
  